import React, { useEffect, useState, useRef } from "react"
import { Link, navigate, graphql } from "gatsby"
import SEO from "../components/seo"
import axios from "axios"
import MediaQuery, { useMediaQuery } from "react-responsive"
import { Formik, Form, Field, ErrorMessage } from "formik"
import * as yup from "yup"
import Collapsible from "react-collapsible"
import { GetQueryStringValue, toTitleCase } from "../utils/utils"
import ProductDetailApi from "../api/signup-product-detail-api"
import SignupApi from "../api/signup-api"
import validations from "../utils/validations"
import serverValidations from "../utils/serverValidations"

import styles from "../styles/signup.module.scss"
import formStyles from "../styles/form-styles.module.scss"

import chevronLeft from "../images/chevron-left.svg"
import chevronDown from "../images/chevron-down.svg"
import pricingBoxBg from "../images/pricingbox-bg.svg"
import phoneIcon from "../images/phone-icon.svg"
import circleError from "../images/circle-x.svg"

export const query = graphql`
  query SIGNUP {
    wpgraphql {
      corePageBy(corePageId: 7136) {
        seo {
          metaDesc
          title
          opengraphTitle
          opengraphDescription
          twitterDescription
          twitterTitle
        }
        acfSignupFaqs {
          faqs {
            title
            subtext
          }
        }
      }
    }
  }
`

const digiCertCertificate = `
<div class="secure-box" id="DigiCertClickID_NnoItP2t" data-language="en">
  <script type="text/javascript">
    var __dcid = __dcid || [];__dcid.push(["DigiCertClickID_NnoItP2t", "3","m", "black", "NnoItP2t"]);(function(){var cid=document.createElement("script");cid.async=true;cid.src="//seal.digicert.com/seals/cascade/seal.min.js";var s = document.getElementsByTagName("script");var ls = s[(s.length - 1)];ls.parentNode.insertBefore(cid, ls.nextSibling);}());
  </script>
</div>
`

const usRegions = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AS", label: "American Samoa" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "DC", label: "District of Columbia" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "GU", label: "Guam" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "MP", label: "Northern Mariana Islands" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "PR", label: "Puerto Rico" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VI", label: "Virgin Islands" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" },
]

const getRegions = country => {
  return new Promise((resolve, reject) => {
    switch (country) {
      case "US":
        resolve(usRegions)
        break
      case "CA":
        resolve([
          { value: "AB", label: "Alberta" },
          { value: "BC", label: "British Columbia" },
          { value: "MB", label: "Manitoba" },
          { value: "NB", label: "New Brunswick" },
          { value: "NL", label: "Newfoundland and Labrador" },
          { value: "NT", label: "Northwest Territories" },
          { value: "NS", label: "Nova Scotia" },
          { value: "NU", label: "Nunavut" },
          { value: "ON", label: "Ontario" },
          { value: "PE", label: "Prince Edward Island" },
          { value: "QC", label: "Quebec" },
          { value: "SK", label: "Saskatchewan" },
          { value: "YT", label: "Yukon" },
        ])
        break
      default:
        resolve([])
    }
  })
}

const SelectCountry = ({
  touched,
  errors,
  isMobile,
  values,
  setFieldValue,
}) => (
  <Field
    as="select"
    className={`${
      touched.country && errors.country ? formStyles.error : null
    } ${formStyles.select}`}
    name="country"
    style={{
      background: `url('${chevronDown}') no-repeat`,
      backgroundPosition: "right 15px center",
      backgroundSize: "auto",
    }}
    onChange={async e => {
      const { value } = e.target
      const _regions = await getRegions(value)
      // console.log(value)
      setFieldValue("country", value)
      setFieldValue("state", "")
      setFieldValue("regions", _regions)
    }}
  >
    {/* <option value="" disabled defaultValue>
      {isMobile ? "Country" : "Select Country"}
    </option> */}

    <option value="US">United States</option>
    <option value="CA">Canada</option>
    <option value="AF">Afghanistan</option>
    <option value="AX">Aland Islands</option>
    <option value="AL">Albania</option>
    <option value="DZ">Algeria</option>
    <option value="AS">American Samoa</option>
    <option value="AD">Andorra</option>
    <option value="AO">Angola</option>
    <option value="AI">Anguilla</option>
    <option value="AQ">Antarctica</option>
    <option value="AG">Antigua and Barbuda</option>
    <option value="AR">Argentina</option>
    <option value="AM">Armenia</option>
    <option value="AW">Aruba</option>
    <option value="AC">Ascension Island</option>
    <option value="AU">Australia</option>
    <option value="AT">Austria</option>
    <option value="AZ">Azerbaijan</option>
    <option value="BS">Bahamas</option>
    <option value="BH">Bahrain</option>
    <option value="BD">Bangladesh</option>
    <option value="BB">Barbados</option>
    <option value="BY">Belarus</option>
    <option value="BE">Belgium</option>
    <option value="BZ">Belize</option>
    <option value="BJ">Benin</option>
    <option value="BM">Bermuda</option>
    <option value="BT">Bhutan</option>
    <option value="BO">Bolivia</option>
    <option value="BW">Botswana</option>
    <option value="BR">Brazil</option>
    <option value="IO">British Indian Ocean Territory</option>
    <option value="BN">Brunei Darussalam</option>
    <option value="BG">Bulgaria</option>
    <option value="BF">Burkina Faso</option>
    <option value="BI">Burundi</option>
    <option value="KH">Cambodia</option>
    <option value="CM">Cameroon</option>
    <option value="CV">Cape Verde</option>
    <option value="KY">Cayman Islands</option>
    <option value="CF">Central African Republic</option>
    <option value="TD">Chad</option>
    <option value="CL">Chile</option>
    <option value="CN">China</option>
    <option value="CX">Christmas Island</option>
    <option value="CC">Cocos Keeling Island</option>
    <option value="CO">Colombia</option>
    <option value="KM">Comoros</option>
    <option value="CG">Congo</option>
    <option value="CD">Congo- Democratic Republic of the</option>
    <option value="CK">Cook Islands</option>
    <option value="CR">Costa Rica</option>
    <option value="CI">Cote D&#39;Ivoire</option>
    <option value="HR">Croatia</option>
    <option value="CU">Cuba</option>
    <option value="CY">Cyprus</option>
    <option value="CZ">Czech Republic</option>
    <option value="DK">Denmark</option>
    <option value="DJ">Djibouti</option>
    <option value="DM">Dominica</option>
    <option value="DO">Dominican Republic</option>
    <option value="EC">Ecuador</option>
    <option value="EG">Egypt</option>
    <option value="SV">El Salvador</option>
    <option value="GQ">Equatorial Guinea</option>
    <option value="ER">Eritrea</option>
    <option value="EE">Estonia</option>
    <option value="ET">Ethiopia</option>
    <option value="FK">Falkland Islands</option>
    <option value="FO">Faroe Islands</option>
    <option value="FJ">Fiji</option>
    <option value="FI">Finland</option>
    <option value="FR">France</option>
    <option value="GF">French Guiana</option>
    <option value="PF">French Polynesia</option>
    <option value="TF">French Southern and Antarctic Lands</option>
    <option value="GA">Gabon</option>
    <option value="GM">Gambia</option>
    <option value="GE">Georgia</option>
    <option value="DE">Germany</option>
    <option value="GH">Ghana</option>
    <option value="GI">Gibraltar</option>
    <option value="GR">Greece</option>
    <option value="GL">Greenland</option>
    <option value="GD">Grenada</option>
    <option value="GP">Guadeloupe</option>
    <option value="GU">Guam</option>
    <option value="GT">Guatemala</option>
    <option value="GG">Guernsey</option>
    <option value="GN">Guinea</option>
    <option value="GW">Guinea-Bissau</option>
    <option value="GY">Guyana</option>
    <option value="HT">Haiti</option>
    <option value="HN">Honduras</option>
    <option value="HK">Hong Kong</option>
    <option value="HU">Hungary</option>
    <option value="IS">Iceland</option>
    <option value="IN">India</option>
    <option value="ID">Indonesia</option>
    <option value="IR">Iran</option>
    <option value="IQ">Iraq</option>
    <option value="IE">Ireland</option>
    <option value="IM">Isle of Man</option>
    <option value="IL">Israel</option>
    <option value="IT">Italy</option>
    <option value="JM">Jamaica</option>
    <option value="JP">Japan</option>
    <option value="JE">Jersey</option>
    <option value="JO">Jordan</option>
    <option value="KZ">Kazakhstan</option>
    <option value="KE">Kenya</option>
    <option value="KI">Kiribati</option>
    <option value="KP">Korea- Democratic People&#39;s Republic of</option>
    <option value="KW">Kuwait</option>
    <option value="KG">Kyrgyzstan</option>
    <option value="LA">Laos</option>
    <option value="LV">Latvia</option>
    <option value="LB">Lebanon</option>
    <option value="LS">Lesotho</option>
    <option value="LR">Liberia</option>
    <option value="LY">Libya</option>
    <option value="LI">Liechtenstein</option>
    <option value="LT">Lithuania</option>
    <option value="LU">Luxembourg</option>
    <option value="MO">Macau</option>
    <option value="MK">Macedonia</option>
    <option value="MG">Madagascar</option>
    <option value="MW">Malawi</option>
    <option value="MY">Malaysia</option>
    <option value="MV">Maldives</option>
    <option value="ML">Mali</option>
    <option value="MT">Malta</option>
    <option value="MH">Marshall Islands</option>
    <option value="MQ">Martinique</option>
    <option value="MR">Mauritania</option>
    <option value="MU">Mauritius</option>
    <option value="YT">Mayotte</option>
    <option value="MX">Mexico</option>
    <option value="FM">Micronesia</option>
    <option value="MD">Moldova</option>
    <option value="MC">Monaco</option>
    <option value="MN">Mongolia</option>
    <option value="ME">Montenegro</option>
    <option value="MS">Montserrat</option>
    <option value="MA">Morocco</option>
    <option value="MZ">Mozambique</option>
    <option value="MM">Myanmar</option>
    <option value="NA">Namibia</option>
    <option value="NR">Nauru</option>
    <option value="NP">Nepal</option>
    <option value="NL">Netherlands</option>
    <option value="NC">New Caledonia</option>
    <option value="NZ">New Zealand</option>
    <option value="NI">Nicaragua</option>
    <option value="NE">Niger</option>
    <option value="NG">Nigeria</option>
    <option value="NU">Niue</option>
    <option value="NF">Norfolk Island</option>
    <option value="MP">Northern Mariana Islands</option>
    <option value="NO">Norway</option>
    <option value="OM">Oman</option>
    <option value="PK">Pakistan</option>
    <option value="PW">Palau</option>
    <option value="PS">Palestine</option>
    <option value="PA">Panama</option>
    <option value="PG">Papua New Guinea</option>
    <option value="PY">Paraguay</option>
    <option value="PE">Peru</option>
    <option value="PH">Philippines</option>
    <option value="PN">Pitcairn</option>
    <option value="PL">Poland</option>
    <option value="PT">Portugal</option>
    <option value="PR">Puerto Rico</option>
    <option value="QA">Qatar</option>
    <option value="RE">Reunion</option>
    <option value="RO">Romania</option>
    <option value="RU">Russia</option>
    <option value="RW">Rwanda</option>
    <option value="SH">Saint Helena</option>
    <option value="KN">Saint Kitts and Nevis</option>
    <option value="LC">Saint Lucia</option>
    <option value="PM">Saint Pierre and Miquelon</option>
    <option value="VC">Saint Vincent and the Grenadines</option>
    <option value="WS">Samoa</option>
    <option value="SM">San Marino</option>
    <option value="ST">Sao Tome and Principe</option>
    <option value="SA">Saudi Arabia</option>
    <option value="SN">Senegal</option>
    <option value="RS">Serbia</option>
    <option value="SC">Seychelles</option>
    <option value="SL">Sierra Leone</option>
    <option value="SG">Singapore</option>
    <option value="SK">Slovakia</option>
    <option value="SI">Slovenia</option>
    <option value="SB">Solomon Islands</option>
    <option value="SO">Somalia</option>
    <option value="ZA">Somaliland</option>
    <option value="ZA">South Africa</option>
    <option value="KR">South Korea</option>
    <option value="ES">Spain</option>
    <option value="LK">Sri Lanka</option>
    <option value="SD">Sudan</option>
    <option value="SR">Suriname</option>
    <option value="SJ">Svalbard and Jan Mayen</option>
    <option value="SZ">Swaziland</option>
    <option value="SE">Sweden</option>
    <option value="CH">Switzerland</option>
    <option value="SY">Syria</option>
    <option value="TW">Taiwan</option>
    <option value="TJ">Tajikistan</option>
    <option value="TZ">Tanzania</option>
    <option value="TH">Thailand</option>
    <option value="TL">Timor-Leste</option>
    <option value="TG">Togo</option>
    <option value="TK">Tokelau</option>
    <option value="TO">Tonga</option>
    <option value="TT">Trinidad Tobago</option>
    <option value="TN">Tunisia</option>
    <option value="TR">Turkey</option>
    <option value="TM">Turkmenistan</option>
    <option value="TC">Turks and Caicos Islands</option>
    <option value="TV">Tuvalu</option>
    <option value="AE">UAE</option>
    <option value="UG">Uganda</option>
    <option value="UA">Ukraine</option>
    <option value="uk">United Kingdom</option>
    <option value="UM">United States Minor Outlying Islands</option>
    <option value="UY">Uruguay</option>
    <option value="UZ">Uzbekistan</option>
    <option value="VU">Vanuatu</option>
    <option value="VA">Vatican City</option>
    <option value="VE">Venezuela</option>
    <option value="VN">Viet Nam</option>
    <option value="VG">Virgin Islands- British</option>
    <option value="VI">Virgin Islands- U.S.</option>
    <option value="WF">Wallis and Futuna Islands</option>
    <option value="EH">Western Sahara</option>
    <option value="YE">Yemen</option>
    <option value="ZM">Zambia</option>
    <option value="ZW">Zimbabwe</option>
  </Field>
)

const SelectState = ({ values, touched, errors, isMobile }) => (
  <Field
    as="select"
    className={`${touched.state && errors.state ? formStyles.error : null} ${
      formStyles.select
    }`}
    name="state"
    style={{
      background: `url('${chevronDown}') no-repeat`,
      backgroundPosition: "right 15px center",
      backgroundSize: "auto",
    }}
  >
    <option value="" disabled defaultValue>
      {/* {isMobile ? "Select" : "State Province"} */}
      {values.country !== "CA" && values.country !== "US" ? "" : "Select"}
      {/* {values.country === "" && "Select"} */}
    </option>

    {values.regions &&
      values.regions.map(r => (
        <option key={r.value} value={r.value}>
          {r.label}
        </option>
      ))}
  </Field>
)

const SelectMonth = ({ touched, errors }) => (
  <Field
    as="select"
    className={`${
      touched.ccExpMonth && errors.ccExpMonth ? formStyles.error : null
    } ${formStyles.select}`}
    name="ccExpMonth"
    style={{
      background: `url('${chevronDown}') no-repeat`,
      backgroundPosition: "right 15px center",
      backgroundSize: "auto",
    }}
  >
    <option value="" disabled defaultValue>
      Month
    </option>
    <option value="01">January</option>
    <option value="02">February</option>
    <option value="03">March</option>
    <option value="04">April</option>
    <option value="05">May</option>
    <option value="06">June</option>
    <option value="07">July</option>
    <option value="08">August</option>
    <option value="09">September</option>
    <option value="10">October</option>
    <option value="11">November</option>
    <option value="12">December</option>
  </Field>
)

const getNextTenYears = () => {
  let thisYear = new Date().getFullYear()
  const maxYear = thisYear + 10
  const yearsArray = []

  while (thisYear < maxYear) {
    yearsArray.push(thisYear)
    thisYear++
  }

  return yearsArray
}

const SelectYear = ({ touched, errors }) => (
  <Field
    as="select"
    className={`${
      touched.ccExpYear && errors.ccExpYear ? formStyles.error : null
    } ${formStyles.select}`}
    name="ccExpYear"
    style={{
      background: `url('${chevronDown}') no-repeat`,
      backgroundPosition: "right 15px center",
      backgroundSize: "auto",
    }}
  >
    <option value="" disabled defaultValue>
      Year
    </option>
    {getNextTenYears().map(year => (
      <option key={year} value={year.toString()}>
        {year.toString()}
      </option>
    ))}
  </Field>
)

let validationSchema = yup.object().shape({
  company: yup.string().max(50, "Company name must not exceed 50 characters"),
  firstName: yup
    .string()
    .required("Enter a first name")
    .max(25, "First name must not exceed 25 characters"),
  lastName: yup
    .string()
    .required("Enter a last name")
    .max(25, "Last name must not exceed 25 characters"),
  email: yup
    .string()
    .min(8, "Email must have 8 characters")
    .max(255, "Email must not exceed 255 characters")
    .required("Enter an email address")
    .email("Must be a valid email address"),
  phoneNumber: yup
    .string()
    .trim()
    .max(15, "Must not exceed 15 digits")
    .required("Enter a phone number")
    .test("CC Phone", "Invalid phone number", function(value) {
      if (value === undefined || value === null) return true
      return validations.validatePhoneNumber(value)
    }),
  phoneExt: yup
    .string()
    .trim()
    .max(8, "Must not exceed 8 digits")
    .test("CC Phone Extension", "Invalid extension", function(value) {
      if (value === undefined || value === null) return true
      return validations.validatePhoneExtension(value)
    }),
  country: yup.string().max(2, "Must not be more than 2 characters"),
  // .required("Select a country"),
  address1: yup
    .string()
    .trim()
    .max(30, "Billing address must not exceed 30 characters")
    .required("Enter a billing address"),
  address2: yup
    .string()
    .trim()
    .max(30, "Billing address 2 must not exceed 30 characters"),
  city: yup
    .string()
    .max(30, "City must not exceed 30 characters")
    .required("Enter a city"),
  state: yup
    .string()
    .max(2)
    .when("country", {
      is: "CA",
      then: yup.string().required("State is required"),
    })
    .when("country", {
      is: "US",
      then: yup.string().required("State is required"),
    }),
  zip: yup
    .string()
    .trim()
    .max(7, "Must not exceed 7 digits")
    .required("Enter zip code"),
  ccName: yup
    .string()
    .trim()
    .max(64, "Name must not exceed 64 characters")
    .required("Enter card holder name")
    .test(
      "CC Card Holder",
      "Enter a valid Card Holder Name. Valid characters are A-Z a-z . ' - space.",
      function(value) {
        if (value === undefined || value === null) return true
        return validations.validateCCHolderName(value)
      }
    ),
  ccNumber: yup
    .string()
    .trim()
    .max(16, "Card length must not exceed 16 digits")
    .required("Enter card number")
    .test("CC Card Number", "Card number is invalid", function(value) {
      if (value === undefined || value === null) return true
      return validations.validateCreditCardNumber(value)
    }),
  ccExpMonth: yup
    .string()
    .max(2, "Must not exceed 2 digits")
    .required("Select expiration month")
    .test("CC Card Expiration", "Card expiration is invalid", function(value) {
      if (value === undefined || value === null) return true
      return validations.validateCreditCardExpiry(this.parent.ccExpYear, value)
    }),
  ccExpYear: yup
    .string()
    .max(4, "must not exceed 4 digits")
    .required("Select expiration year"),
  cvc: yup
    .string()
    .trim()
    .max(5, "Must not exceed 5 digits")
    .required("Enter CVC code"),
  tos: yup.boolean().oneOf([true], "Accept terms of service"),
})

const onSignupSuccess = (result, setErrorCb, setAlertStateCb) => {
  if (result !== null && result.Result !== null) {
    if (result.Result.ReturnCode === 0) {
      const selectedProductID = GetQueryStringValue("pid")
      const confirmUrl =
        "/confirm-signup?pid=" +
        selectedProductID +
        "&a=" +
        btoa(result.Result.NewAccountID)

      // navigate to confirm page
      navigate(confirmUrl)
    } else {
      if (result.Result.ReturnCode === 1) {
        // cybersource error
        switch (result.Result.PaymentReasonCode) {
          case "200":
            // verify billing address
            setAlertStateCb("Please verify billing address/zip code.")
            break
          case "202":
            // supply valid expiration
            setAlertStateCb("Please supply a valid expiration date.")
            break
          case "203":
            // verify number
            setAlertStateCb(
              "Please verify that the number is correct and resubmit or provide a different credit card."
            )
            break
          case "211":
            // supply code
            setAlertStateCb("Please supply a valid verification code.")
            break
          case "231":
            // supply valid card
            setAlertStateCb("Please supply a valid credit card.")
            break
          default:
            // contact support
            setAlertStateCb(
              "An error has occurred. Please contact customer support."
            )
            break
        }
      } else if (result.Result.ReturnCode === 2) {
        // database error
        setAlertStateCb(
          "An error has occurred. Please contact customer support."
        )
      } else {
        //Unexpected error
        setAlertStateCb(
          "An error has occurred. Please contact customer support."
        )
      }
      // EnableSignupButton(true);
    }
  } else {
    setErrorCb(serverValidations.createSignupErrorSchema(result))
  }
}

const SignupForm = ({ isMobile }) => {
  const [alertMessage, setAlertMessage] = useState(null)
  const inputRef = useRef(null)

  useEffect(() => {
    inputRef.current.focus()
  }, [])

  const submitSignup = (values, { setSubmitting, resetForm, setErrors }) => {
    setSubmitting(true)

    var websiteID = 8 //ConferenceCalling
    const productID = GetQueryStringValue("pid")
    const promotionCode = GetQueryStringValue("p")
    const isAnnualSubscription =
      GetQueryStringValue("annual") === "true" ? true : false
    const refid = GetQueryStringValue("refid")

    const data = {
      ProductID: productID,
      CompanyName: values.company.trim(),
      FirstName: values.firstName.trim(),
      LastName: values.lastName.trim(),
      EmailAddress: values.email.trim(),
      Phone: values.phoneNumber.trim(),
      PhoneExt: values.phoneExt.trim(),
      Address1: values.address1.trim(),
      Address2: values.address2.trim(),
      City: values.city.trim(),
      State: values.state,
      ZipCode: values.zip,
      Country: values.country,
      CCNumber: values.ccNumber.trim(),
      CCHolderName: values.ccName.trim(),
      CCExpiryMonth: values.ccExpMonth,
      CCExpiryYear: values.ccExpYear,
      CVCCode: values.cvc.trim(),
      CorporateCC: false,
      PromotionCode: promotionCode,
      FirstRefURL:
        typeof window !== "undefined" && window.sbjs.get.first_add.ep,
      Firstsrc: typeof window !== "undefined" && window.sbjs.get.first.src,
      IsAnnualSubscription: isAnnualSubscription,
      ReferringUserID: refid,
      Referrer: typeof document !== "undefined" && document.referrer,
      WebsiteID: websiteID,
      IsTOSAgreed: values.tos,
    }

    SignupApi(
      data,
      onSignupSuccess,
      setErrors,
      setAlertMessage,
      serverValidations.createSignupErrorSchema,
      setSubmitting
    )
  }

  return (
    <Formik
      initialValues={{
        company: "",
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        phoneExt: "",
        country: "US",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        ccName: "",
        ccNumber: "",
        ccExpMonth: "",
        ccExpYear: "",
        cvc: "",
        tos: false,
        regions: usRegions,
      }}
      validationSchema={validationSchema}
      onSubmit={submitSignup}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        setFieldValue,
      }) => (
        <Form onSubmit={handleSubmit}>
          <div className={styles.formWell}>
            <div className={styles.formsBox}>
              {/* CONTACT INFO */}
              <div className={styles.contact}>
                <div className={styles.header}>
                  <div className={styles.step}>1</div>
                  <div>Contact Information</div>
                </div>

                {/* company row */}
                <div className={`${styles.companyRow} ${styles.inputRow}`}>
                  <label className={formStyles.label} htmlFor="company">
                    <div>Company</div>
                  </label>
                  <Field
                    className={`${
                      touched.company && errors.company
                        ? formStyles.error
                        : null
                    } ${formStyles.input}`}
                    name="company"
                    placeholder="Your Company Name"
                    maxLength="50"
                    innerRef={inputRef}
                  />
                  <ErrorMessage name="company">
                    {msg => <div className={formStyles.errorTip}>{msg}</div>}
                  </ErrorMessage>
                </div>

                {/* first and last row*/}
                <div className={`${styles.nameRow} ${styles.inputRow}`}>
                  <div className={styles.firstNameContainer}>
                    <label className={formStyles.label} htmlFor="firstName">
                      <div className={formStyles.required}>First Name</div>
                    </label>
                    <Field
                      className={`${
                        touched.firstName && errors.firstName
                          ? formStyles.error
                          : null
                      } ${formStyles.input}`}
                      name="firstName"
                      maxLength="25"
                      placeholder="Your First Name"
                    />
                    <ErrorMessage name="firstName">
                      {msg => <div className={formStyles.errorTip}>{msg}</div>}
                    </ErrorMessage>
                  </div>
                  <div className={styles.lastNameContainer}>
                    <label className={formStyles.label} htmlFor="lastName">
                      <div className={formStyles.required}>Last Name</div>
                    </label>
                    <Field
                      className={`${
                        touched.lastName && errors.lastName
                          ? formStyles.error
                          : null
                      } ${formStyles.input}`}
                      name="lastName"
                      maxLength="25"
                      placeholder="Your Last Name"
                    />
                    <ErrorMessage name="lastName">
                      {msg => <div className={formStyles.errorTip}>{msg}</div>}
                    </ErrorMessage>
                  </div>
                </div>

                {/* email and number row*/}
                <div className={`${styles.emailNumberRow} ${styles.inputRow}`}>
                  <div className={styles.emailContainer}>
                    <label className={formStyles.label} htmlFor="email">
                      <div className={formStyles.required}>Email Address</div>
                    </label>
                    <Field
                      className={`${
                        touched.email && errors.email ? formStyles.error : null
                      } ${formStyles.input}`}
                      name="email"
                      maxLength="255"
                      placeholder="Your Email"
                    />
                    <ErrorMessage name="email">
                      {msg => <div className={formStyles.errorTip}>{msg}</div>}
                    </ErrorMessage>
                  </div>
                  <div className={styles.phoneNumberContainer}>
                    <label className={formStyles.label} htmlFor="phoneNumber">
                      <div className={formStyles.required}>Phone Number</div>
                    </label>

                    <Field
                      className={`${
                        touched.phoneNumber && errors.phoneNumber
                          ? formStyles.error
                          : null
                      } ${formStyles.input} ${styles.phoneInput}`}
                      name="phoneNumber"
                      maxLength="15"
                      placeholder="Your Phone Number"
                    />
                    <ErrorMessage name="phoneNumber">
                      {msg => <div className={formStyles.errorTip}>{msg}</div>}
                    </ErrorMessage>
                  </div>
                  <div className={styles.phoneExtContainer}>
                    <label className={formStyles.label} htmlFor="phoneNumber">
                      <div />
                    </label>
                    <Field
                      //className={formStyles.input}
                      name="phoneExt"
                      className={`${
                        touched.phoneExt && errors.phoneExt
                          ? formStyles.error
                          : null
                      } ${formStyles.input}`}
                      placeholder="Ext."
                      maxLength="8"
                    />
                    <ErrorMessage name="phoneExt">
                      {msg => <div className={formStyles.errorTip}>{msg}</div>}
                    </ErrorMessage>
                  </div>
                </div>
              </div>

              {/* BILLING ADDRESS */}
              <div className={styles.billingAddress}>
                <div className={styles.header}>
                  <div className={styles.step}>2</div>
                  <div>Billing Address</div>
                </div>

                {/* country row */}
                <div className={`${styles.countryRow} ${styles.inputRow}`}>
                  <label className={formStyles.label} htmlFor="country">
                    <div className={formStyles.required}>Select Country</div>
                  </label>
                  <SelectCountry
                    touched={touched}
                    errors={errors}
                    isMobile={isMobile}
                    values={values}
                    setFieldValue={setFieldValue}
                  />
                  <ErrorMessage name="country">
                    {msg => <div className={formStyles.errorTip}>{msg}</div>}
                  </ErrorMessage>
                </div>

                {/* billing address 1 and 2 row*/}
                <div className={`${styles.billingRow} ${styles.inputRow}`}>
                  <div className={styles.billingContainer}>
                    <label className={formStyles.label} htmlFor="address1">
                      <div className={formStyles.required}>Billing Address</div>
                    </label>
                    <Field
                      className={`${
                        touched.address1 && errors.address1
                          ? formStyles.error
                          : null
                      } ${formStyles.input}`}
                      name="address1"
                      maxLength="30"
                      placeholder="Billing Address"
                    />
                    <ErrorMessage name="address1">
                      {msg => <div className={formStyles.errorTip}>{msg}</div>}
                    </ErrorMessage>
                  </div>
                  <div className={styles.billingTwoContainer}>
                    <label className={formStyles.label} htmlFor="address2">
                      <div>Billing Address 2</div>
                    </label>
                    <Field
                      className={`${
                        touched.address2 && errors.address2
                          ? formStyles.error
                          : null
                      } ${formStyles.input}`}
                      name="address2"
                      maxLength="30"
                      placeholder="Billing Address 2"
                    />
                    <ErrorMessage name="address2">
                      {msg => <div className={formStyles.errorTip}>{msg}</div>}
                    </ErrorMessage>
                  </div>
                </div>

                {/* city state zip row*/}
                <div className={`${styles.cityStateRow} ${styles.inputRow}`}>
                  <div className={styles.cityContainer}>
                    <label className={formStyles.label} htmlFor="city">
                      <div className={formStyles.required}>City</div>
                    </label>
                    <Field
                      className={`${
                        touched.city && errors.city ? formStyles.error : null
                      } ${formStyles.input}`}
                      name="city"
                      maxLength="30"
                      placeholder="City"
                    />
                    <ErrorMessage name="city">
                      {msg => <div className={formStyles.errorTip}>{msg}</div>}
                    </ErrorMessage>
                  </div>
                  <div className={styles.stateContainer}>
                    <label className={formStyles.label} htmlFor="state">
                      <div>State Province</div>
                    </label>
                    <SelectState
                      touched={touched}
                      errors={errors}
                      isMobile={isMobile}
                      values={values}
                    />
                    <ErrorMessage name="state">
                      {msg => <div className={formStyles.errorTip}>{msg}</div>}
                    </ErrorMessage>
                  </div>
                  <div className={styles.zipContainer}>
                    <label className={formStyles.label} htmlFor="zip">
                      <div>Zip Code</div>
                    </label>
                    <Field
                      className={`${
                        touched.zip && errors.zip ? formStyles.error : null
                      } ${formStyles.input}`}
                      name="zip"
                      maxLength="7"
                      placeholder="Zip"
                    />
                    <ErrorMessage name="zip">
                      {msg => <div className={formStyles.errorTip}>{msg}</div>}
                    </ErrorMessage>
                  </div>
                </div>
              </div>

              {/* BILLING METHOD */}
              <div className={styles.billingMethod}>
                <div className={styles.header}>
                  <div className={styles.step}>3</div>
                  <div>Billing Method</div>
                </div>

                {/* name and supported cards row */}
                <div className={`${styles.nameCardsRow} ${styles.inputRow}`}>
                  <div className={styles.fullNameContainer}>
                    <label className={formStyles.label} htmlFor="ccName">
                      <div className={formStyles.required}>
                        Full Name on Card
                      </div>
                    </label>
                    <Field
                      className={`${
                        touched.ccName && errors.ccName
                          ? formStyles.error
                          : null
                      } ${formStyles.input}`}
                      name="ccName"
                      maxLength="64"
                      placeholder="Full Name on Card"
                    />
                    <ErrorMessage name="ccName">
                      {msg => <div className={formStyles.errorTip}>{msg}</div>}
                    </ErrorMessage>
                  </div>
                  <div className={styles.supportedCardsContainer}>
                    <MediaQuery minWidth={648}>
                      <label className={formStyles.label}>
                        <div>Supported Cards</div>
                      </label>
                    </MediaQuery>

                    <div className={styles.cardIcons}>
                      {/* prettier-ignore */}
                      <svg height="30" width="42" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path d="M42 26a4 4 0 01-4 4H4a4 4 0 01-4-4V4a4 4 0 014-4h34a4 4 0 014 4z" fill="#1976d2"/><path d="M19.255 11l-2.113 4.683L15.039 11h-2.695v6.726L9.341 11H7.067L4 17.981h1.815l.671-1.558h3.432l.682 1.558h3.465v-5.185l2.299 5.185h1.563l2.351-5.095v5.095H22V11zm-12.12 3.915l1.026-2.44 1.066 2.44zm27.748-.502L38 11.018h-2.217l-1.994 2.164L31.86 11H25v6.982h6.635l2.092-2.311L35.767 18h2.21zm-4.155 2.103h-4.011v-1.381h3.838v-1.323h-3.838v-1.308l4.234.012 1.693 1.897z" fill="#fff"/></g></svg>
                      {/* prettier-ignore */}
                      <svg height="30" width="42" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path d="M42 26c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4h34c2.2 0 4 1.8 4 4z" fill="#e1e7ea"/><path d="M42 26c0 2.2-1.8 4-4 4H13s23.6-3.8 29-15zM19 15c0 1.7 1.3 3 3 3s3-1.3 3-3-1.3-3-3-3-3 1.3-3 3z" fill="#ff6d00"/><path d="M8.2 12h1.1v6H8.2zm6 3c0 1.7 1.3 3 3 3 .5 0 .9-.1 1.4-.3v-1.3c-.4.4-.8.6-1.4.6-1.1 0-1.9-.8-1.9-2 0-1.1.8-2 1.9-2 .5 0 .9.2 1.4.6v-1.3c-.5-.2-.9-.4-1.4-.4-1.7.1-3 1.5-3 3.1zm13.4.9L26 12h-1.2l2.5 6h.6l2.5-6h-1.2zm3.3 2.1h3.2v-1H32v-1.6h2v-1h-2V13h2.1v-1h-3.2zm7.6-4.2c0-1.1-.7-1.8-2-1.8h-1.7v6h1.1v-2.4h.1l1.6 2.4H39l-1.8-2.5c.8-.2 1.3-.8 1.3-1.7zm-2.3 1h-.3V13h.3c.7 0 1.1.3 1.1.9 0 .5-.3.9-1.1.9zM4.7 12H3v6h1.6c2.5 0 3.1-2.1 3.1-3 .1-1.8-1.2-3-3-3zm-.3 5h-.3v-4h.4c1.5 0 2.1 1 2.1 2 0 .4-.1 2-2.2 2zm7.9-2.7c-.7-.3-.9-.4-.9-.7 0-.4.4-.6.8-.6.3 0 .6.1.9.5l.6-.8c-.5-.5-1-.7-1.7-.7-1 0-1.8.7-1.8 1.7 0 .8.4 1.2 1.4 1.6.6.2 1.1.4 1.1.9s-.4.8-.9.8-1-.3-1.2-.8l-.7.7c.5.8 1.1 1.1 2 1.1 1.2 0 2-.8 2-1.9 0-.9-.4-1.3-1.6-1.8z" fill="#000"/></g></svg>
                      {/* prettier-ignore */}
                      <svg height="30" width="43" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path d="M42.5 26c0 2.209-1.812 4-4.048 4H4.048C1.812 30 0 28.209 0 26V4c0-2.209 1.812-4 4.048-4h34.404C40.688 0 42.5 1.791 42.5 4z" fill="#1565c0"/><path d="M12.331 10l-2.657 7.832s-.675-3.313-.742-3.729c-1.513-3.411-3.745-3.221-3.745-3.221L7.818 21v-.002h3.199L15.44 10zm2.533 11h2.905l1.757-11h-2.942zm20.56-11h-3.056l-4.766 11h2.886l.595-1.571h3.638l.31 1.571h2.644zm-3.536 7.328l1.582-4.157.828 4.157zm-8.24-4.122c0-.606.503-1.057 1.948-1.057.94 0 2.015.674 2.015.674l.471-2.309s-1.374-.515-2.723-.515c-3.055 0-4.63 1.444-4.63 3.272 0 3.306 4.026 2.853 4.026 4.551 0 .291-.234.964-1.91.964-1.682 0-2.792-.609-2.792-.609l-.501 2.216s1.076.606 3.154.606c2.084 0 4.974-1.54 4.974-3.752 0-2.661-4.033-2.853-4.033-4.041z" fill="#fff"/> <path d="M9.322 15.945l-.978-4.748s-.442-1.029-1.592-1.029H2.26s5.728 1.672 7.062 5.777z" fill="#ffc107"/></g></svg>
                      {/* prettier-ignore */}
                      <svg height="30" width="43" xmlns="http://www.w3.org/2000/svg"> <g fill="none"> <path d="M42.5 26a4 4 0 01-4 4h-34a4 4 0 01-4-4V4a4 4 0 014-4h34a4 4 0 014 4z" fill="#3f51b5"/> <path d="M27.5 5c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10z" fill="#ffc107"/> <path d="M19.514 21a9.983 9.983 0 01-1.176-2h5.325a9.9 9.9 0 00.637-2h-6.598a9.976 9.976 0 01-.202-2h7c0-.686-.07-1.354-.201-2h-6.598a9.964 9.964 0 01.637-2h5.325a9.936 9.936 0 00-1.176-2h-2.973c.437-.58.93-1.122 1.481-1.595A9.955 9.955 0 0014.5 5c-5.523 0-10 4.477-10 10s4.477 10 10 10c3.269 0 6.162-1.575 7.986-4z" fill="#ff3d00"/> </g> </svg>
                    </div>
                  </div>
                </div>

                {/* credit card number row*/}
                <div className={`${styles.creditNumberRow} ${styles.inputRow}`}>
                  <label className={formStyles.label} htmlFor="ccNumber">
                    <div className={formStyles.required}>
                      Credit Card Number
                    </div>
                  </label>
                  <Field
                    className={`${
                      touched.ccNumber && errors.ccNumber
                        ? formStyles.error
                        : null
                    } ${formStyles.input}`}
                    name="ccNumber"
                    maxLength="16"
                    placeholder="Credit Card Number"
                  />
                  <ErrorMessage name="ccNumber">
                    {msg => <div className={formStyles.errorTip}>{msg}</div>}
                  </ErrorMessage>
                </div>

                {/* expiration row*/}
                <div
                  className={`${styles.expirationDateRow} ${styles.inputRow}`}
                >
                  <div className={styles.monthContainer}>
                    <label className={formStyles.label} htmlFor="ccExpMonth">
                      <div className={formStyles.required}>
                        {isMobile ? "Exp Date" : "Expiration Date"}
                      </div>
                    </label>
                    <SelectMonth touched={touched} errors={errors} />
                    <ErrorMessage name="ccExpMonth">
                      {msg => <div className={formStyles.errorTip}>{msg}</div>}
                    </ErrorMessage>
                  </div>
                  <div className={styles.yearContainer}>
                    <label className={formStyles.label} htmlFor="ccExpYear">
                      <div />
                    </label>
                    <SelectYear touched={touched} errors={errors} />
                    <ErrorMessage name="ccExpYear">
                      {msg => <div className={formStyles.errorTip}>{msg}</div>}
                    </ErrorMessage>
                  </div>
                  <div className={styles.cvcContainer}>
                    <label className={formStyles.label} htmlFor="cvc">
                      <div className={formStyles.required}>
                        {isMobile ? "CVC" : "Security Code (CVC)"}
                      </div>
                    </label>
                    <Field
                      className={`${
                        touched.cvc && errors.cvc ? formStyles.error : null
                      } ${formStyles.input}`}
                      name="cvc"
                      maxLength="17"
                      placeholder="CVC"
                    />
                    <ErrorMessage name="cvc">
                      {msg => <div className={formStyles.errorTip}>{msg}</div>}
                    </ErrorMessage>
                  </div>
                </div>
              </div>

              {alertMessage && (
                <div className={styles.alertBox}>
                  <img src={circleError} alt="error icon" />
                  <div>
                    We are unable to process the credit card information
                    provided.
                    <br />
                    {alertMessage}
                  </div>
                </div>
              )}
              <div className={styles.submitContainer}>
                <div className={styles.tosContainer}>
                  <Field id="tos" type="checkbox" name="tos" />
                  <label htmlFor="tos">I agree to the </label>
                  <a href="/terms" target="_blank">
                    <span className={styles.tosButton}>Terms of Service</span>
                  </a>
                  <ErrorMessage name="tos">
                    {msg => <div className={formStyles.errorTip}>{msg}</div>}
                  </ErrorMessage>
                </div>
                <button
                  data-testid="submitButton"
                  disabled={isSubmitting}
                  type="submit"
                  style={{ opacity: isSubmitting ? ".5" : "1" }}
                >
                  {isSubmitting ? "Processing..." : "Create Your Account"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  )
}

const PlanBox = ({ plan }) => (
  <div className={styles.planBox}>
    <div className={styles.planBadge}>YOUR PLAN</div>
    <div className={styles.planType}>{plan.product}</div>
    <div className={styles.planDetail}>
      {plan.maxCallers.includes("callers") && plan.maxCallers}
    </div>
    <div className={styles.totalContainer}>
      <div className={styles.totalLabel}>
        {plan.ratesFrom.length ? plan.ratesFrom.toUpperCase() : `TOTAL`}
      </div>
      <div className={styles.priceContainer}>
        <div
          className={styles.price}
          dangerouslySetInnerHTML={{ __html: plan.total }}
        />
        <span>{plan.billingCycle}</span>
      </div>
    </div>
  </div>
)

const Signup = ({ data }) => {
  const [plan, setPlan] = useState({
    product: "—",
    maxCallers: "",
    total: "—",
    billingCycle: "",
    ratesFrom: "",
  })

  const [modalOpen, setModalOpen] = useState(false)

  const handleModalClick = () => setModalOpen(!modalOpen)

  useEffect(() => {
    ProductDetailApi(
      getProductPayload,
      setPlan,
      toTitleCase,
      productDetailError
    )
  }, [])

  const getProductPayload = () => {
    var selectedProductID = GetQueryStringValue("pid")

    var promotionCode = GetQueryStringValue("p")
    var isAnnualSubscription = false
    if (GetQueryStringValue("annual") === "true") {
      isAnnualSubscription = true
    }
    var showPerMinCostDisplay = false
    if (GetQueryStringValue("disp") === "tf") {
      showPerMinCostDisplay = true
    }

    return {
      ProductId: selectedProductID,
      PromotionCode: promotionCode,
      isAnnualSubscription,
      showPerMinCostDisplay,
    }
  }

  const productDetailError = result => {
    if (result != null) {
      switch (result.ErrorCode) {
        case 100:
          alert("An error has occurred while retrieving product detail.")
          window.location = "/pricing"
          break
        case 101:
          alert("ProductID is not valid.")
          window.location = "/pricing"
          break
        case 102:
          alert("Product does not exist for given ProductId.")
          window.location = "/pricing"
          break
        default:
          alert("Error occurred while getting product detail")
          window.location = "/pricing"
          break
      }
    } else {
      alert("Error occurred while getting product detail")
      window.location = "/pricing"
    }
  }

  const isMobileForm = useMediaQuery({ maxWidth: 648 })
  const seo = data.wpgraphql.corePageBy.seo
  const faqs = data.wpgraphql.corePageBy.acfSignupFaqs.faqs

  return (
    <div className={styles.signupContainer}>
      <SEO {...seo} />
      <div className={styles.formContainer}>
        <div className={styles.formHeader}>
          {/* prettier-ignore */}
          <svg height="29" width="191" xmlns="http://www.w3.org/2000/svg" ><g fill="none"><path d="M12.834 4.93a5.48 5.48 0 00-1.952-2.008c1.195 2.214 1.19 4.655-.806 7.192-.194.247-2.77 3.23-3.218 5.977l-.014.062 2.039 2.087c.449-2.747 3.024-5.73 3.218-5.978 2.038-2.59 2.004-5.08.733-7.331" fill="#0cb4e3" /> <path d="M10.117 10.058c2.033-2.548 2.038-5 .821-7.225a5.949 5.949 0 00-5.992-.016c-2.76 1.6-3.71 5.15-2.12 7.93.026.046 1.38 2.374 3.623 4.951.18.196.165.187.377.427l.014-.062c.457-2.76 3.08-5.757 3.277-6.005" fill="#6457B0" /> <path d="M2.86 10.794a5.754 5.754 0 012.116-7.86 5.973 5.973 0 015.98.016c-.024-.046-.047-.093-.073-.14C9.295.057 5.674-.791 2.918.796A5.754 5.754 0 00.8 8.655c.034.058 2.584 4.046 6.051 7.47-.211-.238-.197-.229-.376-.423-2.239-2.555-3.59-4.862-3.617-4.908" fill="#fe5c93" /> <path d="M13.02 27.851a5.725 5.725 0 01-2.107-7.835l9.933-17.147c1.59-2.744 5.11-3.683 7.862-2.1a5.726 5.726 0 012.107 7.836l-9.933 17.147a5.758 5.758 0 01-4.99 2.87 5.745 5.745 0 01-2.872-.77z" fill="#6457B0" /> <g fill="#6457B0"> <path d="M46.235 22.391l5.513-14.584h-2.612l-4.094 11.355L40.97 7.807h-2.674l5.43 14.584zm8.548.309c1.625 0 2.613-.823 3.086-1.584 0 .802.082 1.214.103 1.275h2.221c-.02-.102-.123-.699-.123-1.604v-4.978c0-1.995-1.173-3.744-4.258-3.744-2.469 0-4.032 1.543-4.217 3.27l2.18.494c.103-1.008.803-1.81 2.057-1.81 1.317 0 1.893.679 1.893 1.522 0 .35-.165.638-.74.72l-2.572.391c-1.707.247-3.024 1.234-3.024 3.024 0 1.584 1.296 3.024 3.394 3.024zm.453-1.872c-.946 0-1.46-.617-1.46-1.296 0-.823.596-1.234 1.336-1.358l2.613-.39v.452c0 1.954-1.152 2.592-2.49 2.592zM66.2 22.7c2.55 0 3.785-1.687 3.785-3.209 0-1.481-.987-2.633-2.88-3.044l-1.522-.309c-.617-.123-1.008-.514-1.008-1.05 0-.616.597-1.151 1.44-1.151 1.337 0 1.769.926 1.851 1.502l2.016-.576c-.164-.988-1.07-2.798-3.867-2.798-2.078 0-3.682 1.481-3.682 3.23 0 1.378.925 2.53 2.695 2.92l1.48.33c.803.164 1.173.576 1.173 1.11 0 .618-.514 1.153-1.502 1.153-1.275 0-1.954-.803-2.036-1.708l-2.078.576C62.19 20.808 63.3 22.7 66.2 22.7zm9.812-.185c.864 0 1.317-.165 1.46-.226v-1.975c-.102.02-.493.082-.822.082-.885 0-1.275-.37-1.275-1.255v-4.649h2.077v-2.118h-2.077V9.309h-2.16v1.501c0 .885-.474 1.564-1.543 1.564h-.514v2.118h1.85v5.04c0 1.872 1.153 2.983 3.004 2.983zM89.034 22.639c3.723 0 5.944-2.366 6.603-4.834l-2.263-.74c-.494 1.645-1.893 3.208-4.34 3.208-2.49 0-4.835-1.81-4.835-5.225 0-3.538 2.407-5.286 4.814-5.286 2.448 0 3.806 1.42 4.238 3.188l2.324-.782c-.658-2.55-2.86-4.73-6.562-4.73-3.785 0-7.344 2.859-7.344 7.61 0 4.752 3.436 7.59 7.365 7.59zm13.285 0c3.004 0 5.205-2.242 5.205-5.328 0-3.065-2.201-5.307-5.205-5.307-2.982 0-5.183 2.242-5.183 5.307 0 3.086 2.2 5.328 5.183 5.328zm0-2.14c-1.46 0-2.797-1.11-2.797-3.188 0-2.078 1.337-3.147 2.797-3.147 1.481 0 2.798 1.07 2.798 3.147 0 2.098-1.317 3.189-2.798 3.189zm9.271 1.831v-5.78c0-1.317.72-2.366 2.078-2.366 1.502 0 2.057.988 2.057 2.222v5.924h2.386v-6.335c0-2.201-1.172-3.97-3.62-3.97-1.11 0-2.304.473-2.962 1.625v-1.338h-2.325V22.33zm12.384 0v-7.94h2.324v-2.078h-2.324v-1.316c0-1.234.843-1.522 1.481-1.522.453 0 .72.061.864.103V7.54c-.165-.082-.658-.206-1.255-.206-2.057 0-3.497 1.358-3.497 3.6v1.378h-1.748v2.078h1.748v7.94zm8.468.309c2.406 0 3.99-1.42 4.525-3.168l-2.016-.638c-.329.988-1.07 1.749-2.51 1.749-1.48 0-2.674-1.09-2.735-2.613h7.323c.02-.04.062-.37.062-.76 0-3.169-1.81-5.205-4.896-5.205-2.53 0-4.875 2.098-4.875 5.266 0 3.394 2.406 5.369 5.122 5.369zm2.242-6.418h-4.917c.083-1.07.947-2.222 2.448-2.222 1.646 0 2.428 1.05 2.469 2.222zm7.076 6.11v-4.773c0-1.872.843-2.942 2.695-2.942.247 0 .514.02.782.062v-2.427a3.417 3.417 0 00-.638-.062c-1.317 0-2.428.638-2.9 1.728v-1.605h-2.325V22.33zm9.71.308c2.406 0 3.99-1.42 4.525-3.168l-2.016-.638c-.33.988-1.07 1.749-2.51 1.749-1.48 0-2.674-1.09-2.735-2.613h7.323c.02-.04.061-.37.061-.76 0-3.169-1.81-5.205-4.895-5.205-2.53 0-4.876 2.098-4.876 5.266 0 3.394 2.407 5.369 5.122 5.369zm2.242-6.418h-4.917c.083-1.07.946-2.222 2.448-2.222 1.646 0 2.427 1.05 2.469 2.222zm7.076 6.11V16.55c0-1.317.72-2.366 2.078-2.366 1.501 0 2.057.988 2.057 2.222v5.924h2.386v-6.335c0-2.201-1.173-3.97-3.62-3.97-1.111 0-2.305.473-2.963 1.625v-1.338h-2.324V22.33zm13.512.308c2.633 0 4.134-1.707 4.607-3.27l-2.098-.762c-.226.761-.946 1.851-2.51 1.851-1.501 0-2.797-1.131-2.797-3.147s1.296-3.106 2.757-3.106c1.522 0 2.2.987 2.427 1.872l2.14-.782c-.412-1.604-1.893-3.291-4.588-3.291-2.88 0-5.122 2.222-5.122 5.307 0 3.045 2.242 5.328 5.184 5.328zm10.964 0c2.407 0 3.99-1.42 4.525-3.168l-2.016-.638c-.329.988-1.07 1.749-2.51 1.749-1.48 0-2.673-1.09-2.735-2.613h7.323c.02-.04.062-.37.062-.76 0-3.169-1.81-5.205-4.896-5.205-2.53 0-4.875 2.098-4.875 5.266 0 3.394 2.406 5.369 5.122 5.369zm2.242-6.418h-4.916c.082-1.07.946-2.222 2.448-2.222 1.645 0 2.427 1.05 2.468 2.222z" /></g></g></svg>
          <Link to="/pricing">
            <button>
              <img src={chevronLeft} alt="back button" />
            </button>
          </Link>
        </div>

        <div className={styles.formContent}>
          <div className={styles.titleHeader}>
            <h1>Create Your Account</h1>
            <div className={styles.titleSubtext}>
              Already have an account? <Link to="/login">Sign in</Link>
            </div>
          </div>

          <div className={styles.mobilePlanContainer}>
            <PlanBox plan={plan} />
          </div>

          <SignupForm isMobile={isMobileForm} />
          <div className={styles.digiCert}>
            <div
              className={styles.digicertContainer}
              dangerouslySetInnerHTML={{ __html: digiCertCertificate }}
            />
          </div>
        </div>
      </div>

      <div className={styles.sidebarContainer}>
        <img
          className={styles.pricingBoxBg}
          src={pricingBoxBg}
          alt="pricing box background"
        />

        <div className={styles.paddingContainer}>
          <div className={styles.desktopPlanContainer}>
            <PlanBox plan={plan} />
          </div>
          <div className={styles.helpContainer}>
            <p>
              Need Help? Call us for immediate assistance with any questions.
            </p>
            <div className={styles.phoneContainer}>
              <img src={phoneIcon} alt="phone icon" />
              1-888-498-9240
            </div>
          </div>
          <div className={styles.collapseContainer} style={{ width: "100%" }}>
            {faqs.map(faq => (
              <Collapsible
                key={faq.title}
                trigger={faq.title}
                transitionTime={300}
                easing="ease"
              >
                <p>{faq.subtext}</p>
              </Collapsible>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Signup
